/**
 * @class ControlSwitch
 *
 * creates a filter switcher like the iPad to show only one filter while drilling down nested data
 *
 */
import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ControlSwitchControl from './controlSwitchControl';
import Icon from '../containers/icon';
const joinValues = valsArray => {
  if (!valsArray || !_.isArray(valsArray) || valsArray.length === 0) {
    return '';
  }
  return valsArray.join(', ');
};

/* eslint-disable react/no-unused-class-component-methods */
export default class ControlSwitch extends Component {
  constructor(props) {
    super(props);

    // keep track of slideDirection
    this.lastSlideDirection = null;
    this.slideRight = 'slide-right';
    this.slideLeft = 'slide-left';
    this.noSlide = null;

    // keep track of the control that is switched to ...
    this.state = {
      selectedControlID: null
    };
    this.switchControl = this.switchControl.bind(this);
  }

  /**
   *  switches to a specific control instead of displaying them all. if set to null,
   *  then it goes back to displaying them all.
   */
  switchControl(control) {
    let newID = null;
    // moving UP the tree, so slide rigth.
    this.slideDirection = this.slideRight;
    if (control) {
      // moving UP the tree, so slide right.
      this.slideDirection = this.slideLeft;
      newID = control.id;
    }
    this.setState({
      selectedControlID: newID
    });
  }

  /* @method render - renders this component.  Assumes props.controls come in
   *   in an array of objects:
   *   [ {
   *        name: <controlName>,
   *        control: <renderedComponent>
   *        values: <array of string values>
   *        id: <uniqueId>  // could be anything - e.g. 'ReportTag' if unique.
   *    },
   *    {
   *        name: <controlName>,
   *        control: <renderedComponent>
   *        values: <array of string values>
   *        id: <uniqueId>  // could be anything - e.g. 'ReportTag' if unique.
   *    }
   *    ]
   */
  render() {
    let children = [];
    let slideDirection = '';
    const clearStyle = {
      clear: 'both'
    };
    const {
      controls,
      onBack
    } = this.props;
    const {
      selectedControlID
    } = this.state;

    // a selected control can disappear while it is open, e.g. a cabinet filter the server
    // cannot offer options for, in which case fall back to the list instead of showing nothing
    const selectedControl = selectedControlID ? _.find(controls, controlObj => controlObj.id === selectedControlID) : undefined;
    if (controls) {
      if (selectedControl) {
        slideDirection = this.slideLeft;
        // show only that control...
        children = selectedControl.control;
      } else {
        // get classNames for sliding.
        if (!_.isEmpty(this.lastSlideDirection)) {
          slideDirection = this.slideRight;
        }
        controls.forEach(control => {
          children.push(/*#__PURE__*/React.createElement(ControlSwitchControl, {
            control: control,
            key: control.id,
            onClick: this.switchControl
          }, `${control.name} `, /*#__PURE__*/React.createElement("div", {
            "aria-label": "control-switch-right",
            role: "link",
            tabIndex: 0,
            className: "float-md-right fade-in t-cs-fade-in",
            style: {
              outline: 'none',
              cursor: 'pointer'
            },
            onClick: onBack,
            onKeyPress: onBack
          }, /*#__PURE__*/React.createElement(Icon, {
            glyph: "angle-right"
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              clear: 'both'
            }
          }), /*#__PURE__*/React.createElement("small", null, joinValues(control.values())), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
            style: clearStyle
          })));
        });
      }
    }
    this.lastSlideDirection = slideDirection;
    return /*#__PURE__*/React.createElement("div", {
      ref: input => {
        this.controlSwitch = input;
      },
      className: "control-switch animation-wrapper "
    }, /*#__PURE__*/React.createElement("div", {
      className: slideDirection
    }, children, /*#__PURE__*/React.createElement("div", {
      style: clearStyle
    })), /*#__PURE__*/React.createElement("div", {
      style: clearStyle
    }));
  }
}
ControlSwitch.propTypes = {
  controls: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    control: PropTypes.shape({})
  })).isRequired,
  onBack: PropTypes.func.isRequired
};